import { Button } from "@firecms/ui";

const leaveButtonClassName =
  "shrink-0 gap-1.5 border-red-600 bg-white/95 text-red-600 hover:bg-red-50 dark:border-red-500 dark:bg-surface-800 dark:text-red-400 dark:hover:bg-red-950/40";

type WorkspaceLeaveControlProps = {
  label: string;
  onBack: () => void;
};

export function WorkspaceLeaveControl({ label, onBack }: WorkspaceLeaveControlProps) {
  return (
    <Button
      variant="outlined"
      size="small"
      className={leaveButtonClassName}
      onClick={(event) => {
        event.stopPropagation();
        onBack();
      }}
    >
      <span className="material-icons text-[16px]" aria-hidden>
        close
      </span>
      <span className="whitespace-nowrap">{label}</span>
    </Button>
  );
}
